import { RatingAttribute, RatingCategory, RosterLocation } from "./models"
import { capitalize } from "../utility"

type RatingType = "Category" | "Attribute"

type RatingBase = {
    type: RatingType,
    title?: string,
    category?: RatingCategory,
    attribute?: RatingAttribute,
    positionsOverride?: RosterLocation[]
}

type RatingWithCategory = RatingBase & {
    type: "Category",
    category: RatingCategory,
}

type RatingWithAttribute = RatingBase & {
    type: "Attribute",
    attribute: RatingAttribute,
}

export type Rating = RatingWithCategory | RatingWithAttribute

const Batting: Rating = {
    type: "Category",
    category: "batting",
}
const Running: Rating = {
    type: "Category",
    category: "running",
}
const Defense: Rating = {
    type: "Category",
    category: "defense",
}
const Pitching: Rating = {
    type: "Category",
    category: "pitching",
}
const Vibes: Rating = {
    type: "Category",
    category: "vibes",
}
const LineupVibes: Rating = {
    type: "Category",
    category: "vibes",
    positionsOverride: ["LINEUP"],
    title: "Lineup Vibes"
}
const RotationVibes: Rating = {
    type: "Category",
    category: "vibes",
    positionsOverride: ["ROTATION"],
    title: "Rotation Vibes"
}

export const Ratings = {
    Batting,
    Running,
    Defense,
    Pitching,
    Vibes
}

export const CustomRatings = {
    LineupVibes,
    RotationVibes
}

export function labelText(rating: Rating) {
    if (rating.title) {
        return rating.title;
    }
    if (rating.type === "Category") {
        return capitalize(rating.category)
    }
    return capitalize(rating.attribute)
}
